import { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import {
    oneClient,
    getClient,
    storeClientPolicies,
    getClientTermsAndPrivacy,
    clientTermsAndPrivacy,
    clientDataStore,
} from '../../../../redux/slices/clientsSlice';
import { useParams } from 'react-router-dom';
import { Button, Radio, Space } from 'antd';
import { toast } from 'react-toastify';

import StandartTerms from './StandartTerms';
import SpecificTerms from './SpecificTerms';
import MultinationalTabs from '../../../../components/MultinationalTabs';
import {
    getPolicies,
    allPolicices,
} from '../../../../redux/slices/settingsSlice';
import { languagesOptions } from '../../../../shared/data/clientDetailsOptions';

export default function ClientTermsSubPage() {
    const dispatch = useDispatch();
    const params = useParams();
    const client = useSelector(oneClient);
    const termsAndPrivacy = useSelector(clientTermsAndPrivacy);
    const policies = useSelector(allPolicices);
    const dataStore = useSelector(clientDataStore);

    const countriesLocalizationsData = useMemo(
        () =>
            termsAndPrivacy?.policy?.reduce((acc, el) => {
                acc[el.country_code] = { terms_of_use: el.terms_of_use };
                return acc;
            }, {}),
        [termsAndPrivacy],
    );

    const [excludedCodes, setExcludedCodes] = useState([]);
    const [data, setData] = useState({
        use_default_pp: 1,
        use_default_tc: 1,
        policies: {
            sv: {
                terms_of_use: '',
            },
            no: {
                terms_of_use: '',
            },
            fi: {
                terms_of_use: '',
            },
            da: {
                terms_of_use: '',
            },
            en: {
                terms_of_use: '',
            },
            is: {
                terms_of_use: '',
            },
        },
    });
    const [radioButtonValue, setRadioButtonValue] = useState('standart');

    useEffect(() => {
        dispatch(getPolicies());
    }, [dispatch]);

    useEffect(() => {
        setData({
            use_default_pp: termsAndPrivacy?.use_default_pp,
            use_default_tc: termsAndPrivacy?.use_default_tc,
            policies: {
                sv: {
                    terms_of_use: countriesLocalizationsData?.sv?.terms_of_use,
                },
                no: {
                    terms_of_use: countriesLocalizationsData?.no?.terms_of_use,
                },
                fi: {
                    terms_of_use: countriesLocalizationsData?.fi?.terms_of_use,
                },
                da: {
                    terms_of_use: countriesLocalizationsData?.da?.terms_of_use,
                },
                en: {
                    terms_of_use: countriesLocalizationsData?.en?.terms_of_use,
                },
                is: {
                    terms_of_use: countriesLocalizationsData?.is?.terms_of_use,
                },
            },
        });
        setRadioButtonValue(
            termsAndPrivacy?.use_default_tc ? 'standart' : 'specific',
        );
    }, [countriesLocalizationsData, termsAndPrivacy]);

    useEffect(() => {
        if (!!Object.keys(dataStore).length) {
            const excludedCodes = languagesOptions
                .filter((option) => option.id !== 'EN')
                .filter(
                    (option) =>
                        !dataStore?.account_languages?.includes(option.id),
                )
                .map((item) => item.id.toLowerCase());

            setExcludedCodes(excludedCodes);
        }
    }, [dataStore]);

    const onRadioButtonsChange = (e) => {
        setRadioButtonValue(e.target.value);
        setData({
            ...data,
            use_default_tc: e.target.value === 'standart' ? 1 : 0,
        });
    };

    const onChangeMultinational = (text, flag) => {
        const newData = {
            ...data,
            policies: { ...data.policies, [flag]: { terms_of_use: text } },
        };

        setData(newData);
    };

    const onSaveSpecificTerms = async () => {
        try {
            await dispatch(
                storeClientPolicies({ id: params.id, body: data }),
            ).unwrap();
            toast.success('Changes saved successfully');
            dispatch(getClientTermsAndPrivacy(client.id));
            dispatch(getClient(client.id));
        } catch (error) {
            toast.error(error);
        }
    };

    const onSaveType = async () => {
        await dispatch(
            storeClientPolicies({ id: params.id, body: data }),
        ).unwrap();

        await dispatch(getClientTermsAndPrivacy(client.id)).unwrap();
        toast.success('Type of Terms of Use changed successfully');
    };

    return (
        <div>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Terms & Conditions`}</title>
            </Helmet>
            <div className="terms-and-privacy-buttons__wrapper">
                <div className="form__item-wrapper--column">
                    <p className="input-label">What terms of use?</p>
                    <Radio.Group
                        onChange={onRadioButtonsChange}
                        value={radioButtonValue}
                    >
                        <Space direction="horizontal">
                            <Radio value="standart">Standart</Radio>
                            <Radio value="specific">Partner specific</Radio>
                        </Space>
                    </Radio.Group>
                </div>
                <div>
                    <Button type="primary" size="large" onClick={onSaveType}>
                        <span>Save</span>
                    </Button>
                </div>
            </div>
            {radioButtonValue === 'standart' && (
                <MultinationalTabs excludedCodes={excludedCodes}>
                    <StandartTerms data={policies} />
                </MultinationalTabs>
            )}
            {radioButtonValue === 'specific' && (
                <SpecificTerms
                    data={data}
                    onChangeMultinational={onChangeMultinational}
                    excludedCodes={excludedCodes}
                    onSave={onSaveSpecificTerms}
                />
            )}
        </div>
    );
}
